import { makeStyles } from '@mui/styles';

const useDropDownStyles = makeStyles({
	root: {
		marginTop: -2,
	},
	titleContainer: {
		alignItems: 'center',
		cursor: 'pointer',
		display: 'flex',
		flexFlow: 'row wrap',
		justifyContent: 'space-between',
		width: '100%',
	},
	listContainer: {
		maxHeight: 283,
		width: '339px',
		zIndex: 2,
		borderRadius: 10,
		marginTop: 10,
		'&:not(:empty)': {
			backgroundColor: 'white',
			boxShadow: '0px 1px 2px #02191933',
			paddingBottom: 31,
			paddingLeft: 20,
			paddingRight: 14,
			paddingTop: 15,
		},
		'&:before': {
			content: '""',
			display: 'block',
			position: 'absolute',
			top: '-15px',
			left: 30,
			borderBottom: '15px solid white',
			borderLeft: '15px solid transparent',
			borderRight: '15px solid transparent',
			marginTop: 10,
			width: 1,
		},
	},
	tipy: {
		overflowX: 'hidden',
		overflowY: 'auto',
		'&::-webkit-scrollbar': {
			width: 6,
		},
		'&::-webkit-scrollbar-track': {
			backgroundColor: '#E9E9E9',
			borderRadius: 7,
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#c7c7c7',
			borderRadius: 7,
		},
		maxHeight: 243,
		width: '95%',
		margin: 'auto',
	},
});

export default useDropDownStyles;
